import script from "./CategoriaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriaView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__